export default "__VITE_ASSET__CJl2rzJi__"